import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_bootstrapvue_00db6a3e from 'nuxt_plugin_bootstrapvue_00db6a3e' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_workbox_79bdcf4e from 'nuxt_plugin_workbox_79bdcf4e' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_9e9c2f3e from 'nuxt_plugin_metaplugin_9e9c2f3e' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_954ce456 from 'nuxt_plugin_iconplugin_954ce456' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_axios_60fb829c from 'nuxt_plugin_axios_60fb829c' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_bootstrap_0a49ca20 from 'nuxt_plugin_bootstrap_0a49ca20' // Source: ../plugins/bootstrap.js (mode: 'all')
import nuxt_plugin_veeValidate_1cb8e4d4 from 'nuxt_plugin_veeValidate_1cb8e4d4' // Source: ../plugins/veeValidate (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_vuemultiselect_f0c5f110 from 'nuxt_plugin_vuemultiselect_f0c5f110' // Source: ../plugins/vue-multiselect (mode: 'all')
import nuxt_plugin_vueawesomeswiper_4c7fbf9a from 'nuxt_plugin_vueawesomeswiper_4c7fbf9a' // Source: ../plugins/vue-awesome-swiper.js (mode: 'client')
import nuxt_plugin_vuesweetalert2_1def2d6e from 'nuxt_plugin_vuesweetalert2_1def2d6e' // Source: ../plugins/vue-sweetalert2 (mode: 'all')
import nuxt_plugin_iziToast_7c2b6925 from 'nuxt_plugin_iziToast_7c2b6925' // Source: ../plugins/iziToast (mode: 'all')
import nuxt_plugin_jalaliCalendar_456c3286 from 'nuxt_plugin_jalaliCalendar_456c3286' // Source: ../plugins/jalaliCalendar (mode: 'all')
import nuxt_plugin_ckeditor_251af56a from 'nuxt_plugin_ckeditor_251af56a' // Source: ../plugins/ckeditor (mode: 'client')
import nuxt_plugin_helper_619f8ab8 from 'nuxt_plugin_helper_619f8ab8' // Source: ../plugins/helper (mode: 'all')
import nuxt_plugin_ErrorHandler_b7619a90 from 'nuxt_plugin_ErrorHandler_b7619a90' // Source: ../plugins/ErrorHandler (mode: 'all')
import nuxt_plugin_GlobalComponents_fc51b2a2 from 'nuxt_plugin_GlobalComponents_fc51b2a2' // Source: ../plugins/GlobalComponents (mode: 'all')
import nuxt_plugin_GlobalDirectives_ac38b4c6 from 'nuxt_plugin_GlobalDirectives_ac38b4c6' // Source: ../plugins/GlobalDirectives (mode: 'all')
import nuxt_plugin_filters_14a52510 from 'nuxt_plugin_filters_14a52510' // Source: ../plugins/filters.js (mode: 'all')
import nuxt_plugin_api_785206da from 'nuxt_plugin_api_785206da' // Source: ../plugins/api.js (mode: 'all')
import nuxt_plugin_auth_1cb46784 from 'nuxt_plugin_auth_1cb46784' // Source: ./auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"دکتر فهیمه شاهرخی - پنل ادمین","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"دکتر فهیمه شاهرخی - پنل ادمین"},{"hid":"charset","charset":"utf-8"},{"hid":"mobile-web-app-capable","name":"mobile-web-app-capable","content":"yes"},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":"dr_shahrokhi_admin_panel"},{"hid":"og:type","name":"og:type","property":"og:type","content":"website"},{"hid":"og:title","name":"og:title","property":"og:title","content":"dr_shahrokhi_admin_panel"},{"hid":"og:site_name","name":"og:site_name","property":"og:site_name","content":"dr_shahrokhi_admin_panel"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"hid":"shortcut-icon","rel":"shortcut icon","href":"\u002F_nuxt\u002Ficons\u002Ficon_64x64.ad9f24.png"},{"hid":"apple-touch-icon","rel":"apple-touch-icon","href":"\u002F_nuxt\u002Ficons\u002Ficon_512x512.ad9f24.png","sizes":"512x512"},{"rel":"manifest","href":"\u002F_nuxt\u002Fmanifest.32eabe5f.json","hid":"manifest"}],"script":[],"style":[],"htmlAttrs":{"lang":"en"}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_bootstrapvue_00db6a3e === 'function') {
    await nuxt_plugin_bootstrapvue_00db6a3e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_79bdcf4e === 'function') {
    await nuxt_plugin_workbox_79bdcf4e(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_9e9c2f3e === 'function') {
    await nuxt_plugin_metaplugin_9e9c2f3e(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_954ce456 === 'function') {
    await nuxt_plugin_iconplugin_954ce456(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_60fb829c === 'function') {
    await nuxt_plugin_axios_60fb829c(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrap_0a49ca20 === 'function') {
    await nuxt_plugin_bootstrap_0a49ca20(app.context, inject)
  }

  if (typeof nuxt_plugin_veeValidate_1cb8e4d4 === 'function') {
    await nuxt_plugin_veeValidate_1cb8e4d4(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (typeof nuxt_plugin_vuemultiselect_f0c5f110 === 'function') {
    await nuxt_plugin_vuemultiselect_f0c5f110(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueawesomeswiper_4c7fbf9a === 'function') {
    await nuxt_plugin_vueawesomeswiper_4c7fbf9a(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesweetalert2_1def2d6e === 'function') {
    await nuxt_plugin_vuesweetalert2_1def2d6e(app.context, inject)
  }

  if (typeof nuxt_plugin_iziToast_7c2b6925 === 'function') {
    await nuxt_plugin_iziToast_7c2b6925(app.context, inject)
  }

  if (typeof nuxt_plugin_jalaliCalendar_456c3286 === 'function') {
    await nuxt_plugin_jalaliCalendar_456c3286(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_ckeditor_251af56a === 'function') {
    await nuxt_plugin_ckeditor_251af56a(app.context, inject)
  }

  if (typeof nuxt_plugin_helper_619f8ab8 === 'function') {
    await nuxt_plugin_helper_619f8ab8(app.context, inject)
  }

  if (typeof nuxt_plugin_ErrorHandler_b7619a90 === 'function') {
    await nuxt_plugin_ErrorHandler_b7619a90(app.context, inject)
  }

  if (typeof nuxt_plugin_GlobalComponents_fc51b2a2 === 'function') {
    await nuxt_plugin_GlobalComponents_fc51b2a2(app.context, inject)
  }

  if (typeof nuxt_plugin_GlobalDirectives_ac38b4c6 === 'function') {
    await nuxt_plugin_GlobalDirectives_ac38b4c6(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_14a52510 === 'function') {
    await nuxt_plugin_filters_14a52510(app.context, inject)
  }

  if (typeof nuxt_plugin_api_785206da === 'function') {
    await nuxt_plugin_api_785206da(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_1cb46784 === 'function') {
    await nuxt_plugin_auth_1cb46784(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
